interface SheetItem {
    sheet_name: string;
    head: string[];
    body: string[][];
}

export interface ApiGetClaimCompareExportRequest {
    file_name: string;
    charts: SheetItem[];
}

export const GetClaimCompareExport = Symbol.for('GetClaimCompareExport');

export interface GetClaimCompareExport {
    getClaimCompareExport(request: ApiGetClaimCompareExportRequest): Promise<string>;
}